import { formatUsdFromCents } from "./CurrencyUtils";
import type { BusinessListingJobType, BusinessListingPayType } from "../types/businessListingTypes";

export const businessListingJobTypeOptions: Array<{ value: BusinessListingJobType; label: string }> = [
  { value: "FULL_TIME", label: "Full Time" },
  { value: "PART_TIME", label: "Part Time" },
  { value: "CONTRACT", label: "Contract" },
  { value: "INTERNSHIP", label: "Internship" },
  { value: "VOLUNTEER", label: "Volunteer" },
];

export const businessListingPayTypeOptions: Array<{ value: BusinessListingPayType; label: string }> = [
  { value: "HOURLY", label: "Hourly" },
  { value: "DAILY", label: "Daily" },
  { value: "WEEKLY", label: "Weekly" },
  { value: "MONTHLY", label: "Monthly" },
  { value: "ANNUALLY", label: "Annually" },
  { value: "ONE_TIME", label: "One Time" },
];

export const formatBusinessListingJobType = (jobType: BusinessListingJobType) =>
  businessListingJobTypeOptions.find((option) => option.value === jobType)?.label ?? jobType;

const payTypeSuffix: Record<BusinessListingPayType, string> = {
  HOURLY: "/hr",
  DAILY: "/day",
  WEEKLY: "/week",
  MONTHLY: "/month",
  ANNUALLY: "/year",
  ONE_TIME: " one-time",
};

export const formatBusinessListingCompensation = (
  payType: BusinessListingPayType,
  minPayAmountCents: number,
  maxPayAmountCents: number,
  jobType?: BusinessListingJobType | null,
) => {
  if (jobType === "VOLUNTEER") {
    return "Volunteer";
  }

  const minAmount = formatUsdFromCents(minPayAmountCents);
  const maxAmount = formatUsdFromCents(maxPayAmountCents);
  const suffix = payTypeSuffix[payType];

  if (minPayAmountCents === maxPayAmountCents) {
    return `${minAmount}${suffix}`;
  }

  return `${minAmount} - ${maxAmount}${suffix}`;
};

export const formatBusinessListingDuration = (minutes: number | null) => {
  if (minutes === null) {
    return null;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours === 0) {
    return `${remainingMinutes} min`;
  }
  if (remainingMinutes === 0) {
    return `${hours} hr${hours === 1 ? "" : "s"}`;
  }
  return `${hours} hr ${remainingMinutes} min`;
};
